module.exports = __webpack_public_path__ + "img/delete-sentosa.a731e96f.svg";